export default __webpack_public_path__ + "static/media/deltar.64fa8d9a.png";